import { Icon } from '@eventbrite/eds-icon';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import classNames from 'classnames';
import React from 'react';
import './AuthDialogIcon.scss';

export interface IAuthDialogIconProps {
    iconType?: React.ReactElement;
    iconColor?: string;
    isLoading?: boolean;
}

const AuthDialogIcon = ({
    iconType,
    iconColor = 'ui-700',
    isLoading,
}: IAuthDialogIconProps) => {
    const classes = classNames(
        'eds-l-mar-bot-4',
        'eds-fx--pop eds-fx--delay-1',
        'eds-text--center',
        'auth-lib__auth-dialog__icon',
    );

    let icon = (
        <ProgressIndicator
            size="medium-chunky"
            shape="circular"
            style="gradient"
        />
    );

    if (iconType && !isLoading) {
        icon = <Icon size="medium" type={iconType} color={iconColor} />;
    }

    return (
        <div className={classes} data-testid="auth-dialog-icon">
            {icon}
        </div>
    );
};

export default AuthDialogIcon;
